var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"like_icon_group"},[_c('div',{staticClass:"like_wrap"},[_c('div',{staticClass:"like_img mr10",class:{'active': _vm.isMyLike()},on:{"click":function($event){return _vm.like()}}}),_c('div',{staticClass:"like_count",on:{"click":function($event){return _vm.like()}}},[_vm._v(_vm._s(_vm.returnLike()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }